var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0019 19C16.5323 19 17.041 18.7893 17.4161 18.4142C17.7911 18.0391 18.0019 17.5304 18.0019 17C18.0019 16.4696 17.7911 15.9609 17.4161 15.5858C17.041 15.2107 16.5323 15 16.0019 15C15.4714 15 14.9627 15.2107 14.5876 15.5858C14.2126 15.9609 14.0019 16.4696 14.0019 17C14.0019 17.5304 14.2126 18.0391 14.5876 18.4142C14.9627 18.7893 15.4714 19 16.0019 19ZM6.00586 19C6.53629 19 7.045 18.7893 7.42007 18.4142C7.79515 18.0391 8.00586 17.5304 8.00586 17C8.00586 16.4696 7.79515 15.9609 7.42007 15.5858C7.045 15.2107 6.53629 15 6.00586 15C5.47543 15 4.96672 15.2107 4.59165 15.5858C4.21657 15.9609 4.00586 16.4696 4.00586 17C4.00586 17.5304 4.21657 18.0391 4.59165 18.4142C4.96672 18.7893 5.47543 19 6.00586 19Z",
    stroke: "#FDA214",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0041 10L5.00606 1M5.00606 1L7.00606 11M5.00606 1H2.83806C2.64806 1 2.48906 1.161 2.46606 1.375L2.13306 4.43C2.75306 4.43 3.25706 5.005 3.25706 5.715C3.25706 6.425 2.75406 7 2.13306 7C1.64306 7 1.16306 6.642 1.00806 6.143M18.0001 17C20.6831 17 21.0001 16.072 21.0001 13.512C21.0001 12.287 21.0001 11.675 20.7601 11.158C20.5101 10.618 20.0581 10.281 19.1081 9.593C18.1651 8.909 17.4941 8.141 16.8551 7.083C15.9431 5.573 15.4881 4.818 14.8051 4.409C14.1201 4 13.3141 4 11.7021 4H11.0021V11",
    stroke: "#FDA214",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00695 16.9962C4.00695 16.9962 2.84695 17.0062 2.48695 16.9602C2.18695 16.8402 1.82295 16.5582 1.58695 16.4022C0.866954 15.9232 1.01195 16.1202 1.01195 15.6882L1.00795 12.0062V11.0462C1.00795 10.9862 0.945954 10.9992 1.40795 11.0062H20.48M8.00495 17.0022H14.003",
    stroke: "#FDA214",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.66ee9d7203147fc42638cfd8ca40bed2.svg";
export { ForwardRef as ReactComponent };